interface ProgressRangeOptions {
    onMouseUp?: ((number) => void) | null;
    onSlide?: ((number) => void) | null;
}

const ProgressRangeDefaultOptions: ProgressRangeOptions = {
    onMouseUp: null,
    onSlide: null,
}

class ProgressRange {
    protected wrapper;
    protected slider;
    protected options;
    protected mouseDownOnSlider = false;

    constructor(selector, options: ProgressRangeOptions) {
        this.options = {...ProgressRangeDefaultOptions, ...options};

        this.wrapper = document.querySelector(selector) as HTMLElement;
        if (!this.wrapper && this.wrapper.offsetWidth > 0)
            return;

        this.slider = this.wrapper.querySelector('.progress-slider') as HTMLElement;

        this.wrapper.onpointerdown = (event) => {
            this.wrapper.setPointerCapture(event.pointerId);
            this.mouseDownOnSlider = true;

            this.setProgress(event.clientX, this.wrapper.offsetWidth);

            this.wrapper.onpointermove = (event) => {
                this.setProgress(event.pageX, this.wrapper.offsetWidth);
            }

            this.wrapper.onpointerup = (event) => {
                this.wrapper.onpointermove = null;
                this.wrapper.onpointerup = null;

                this.mouseDownOnSlider = false;
                this.onMouseUp((event.clientX - this.slider.getBoundingClientRect().x) / this.wrapper.offsetWidth * 100)
            };

           /* this.wrapper.ontouchend = (event) => {
                this.mouseDownOnSlider = false;
                this.onMouseUp(event.clientX / this.wrapper.offsetWidth * 100)
            }*/
        };

        /*


            alert((window, "PointerEvent") !== undefined)
            alert("ontouchstart" in window)

        this.wrapper.onmousedown = (event) => {
          //  this.wrapper.setPointerCapture(event.pointerId);
            this.mouseDownOnSlider = true;
            this.setProgress(event.clientX / this.wrapper.offsetWidth * 100);

            const mouseMove = (event) => {
                this.setProgress(event.pageX / this.wrapper.offsetWidth * 100);
            }

            const mouseUp = (event) => {
                window.removeEventListener('mousemove', mouseMove)
                window.removeEventListener('mouseup', mouseMove)
                this.mouseDownOnSlider = false;
                this.onMouseUp(event.clientX / this.wrapper.offsetWidth * 100)
            }

            window.addEventListener('mousemove', mouseMove)
            window.addEventListener('mouseup', mouseUp)


        };*/
    }

    public setProgress(current, max = 100) {

        const percent = (current - this.slider.getBoundingClientRect().x) / max * 100;

        this.slider.style.width = percent + '%'
        if (this.options.onSlide)
            this.options.onSlide(percent)
    }

    public onMouseUp(percent) {
        if (this.options.onMouseUp)
            this.options.onMouseUp(percent)
    }

}

export default ProgressRange;
